// extracted by mini-css-extract-plugin
export default {"plans":"Plans-module--plans--YJz2K","title":"Plans-module--title--gQRiI","container":"Plans-module--container--1yBMU"};